const wizardComponentsHelper = require('../../utilities/wizardComponenstHelper');
const inputs = require('../../fioc/inputs');
const inputsFioc = wizardComponentsHelper.replacePrefix(inputs.fioc);

const step1 = require('./step1');
const step1TC = require('./step1TC');
// const step2 = require('./step2');

const contract = {
    title: 'profile-dataUpdate',
    last_step: 2,
    code_op: 152, // Use 152 this when OTP is needed
    showCurrentUser: true,
    hireParamsFn: 'fioc_HireParams',
    hireBtnLabel: 'profileFioc-buttonUpdate',
    define_steps: 1,
    onCancelURL: '/myprofile/edit',
    showHelpBar: true,
    breadcrumb: [
        {
            text: 'breadcrumb-personalInformation',
            url: '/myprofile/edit'
        },
        {
            text: 'breadcrumb-fioc'
        }
    ],
    state: {
        card_details_title: 'contractsView-cardDetailsTitle',
        card_details: [
            //Forms Values
            {
                id: 'fioc_profession_category',
                value: '',
                isErrorVisible: false,
                required: true
            },
            {//This is necessary to stop the steps navigation in step 2 and validate OTP
                id: 'n_steps',
                label: '',
                value: 2,
                type: 'array',
                format_type: '',
                order: 12,
                visible: []
            },
            ...wizardComponentsHelper.returnObjectsFromArrayComponents(inputsFioc),
        ]
    },
    steps: [
        step1
    ]
};

const contractTC = {
    ...contract,
    steps: [
        step1TC
    ]
};

module.exports = {
    contract,
    contractTC
};